export default __webpack_public_path__ + "static/media/banner-section-1.0cbf5b6d.jpg";